import { getThemeClass, getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";
import type { ClipboardEvent, KeyboardEvent, MutableRefObject } from "react";

type OtpCodeInputProps = {
  values: string[];
  inputsRef: MutableRefObject<(HTMLInputElement | null)[]>;
  onPaste?: (event: ClipboardEvent<HTMLInputElement>, index: number) => void;
  onChange: (value: string, index: number) => void;
  onKeyDown: (event: KeyboardEvent, index: number) => void;
};

export default function OtpCodeInput({
  values,
  inputsRef,
  onPaste,
  onChange,
  onKeyDown,
}: OtpCodeInputProps) {
  const inputClasses = getThemeComponentClasses().input;

  return (
    <div className="flex gap-2 justify-between">
      {values.map((digit, index) => (
        <input
          key={index}
          ref={(element) => {
            inputsRef.current[index] = element;
          }}
          type="text"
          maxLength={1}
          value={digit}
          inputMode="numeric"
          onPaste={(event) => onPaste?.(event, index)}
          onChange={(event) => onChange(event.target.value, index)}
          onKeyDown={(event) => onKeyDown(event, index)}
          className={`w-12 h-12 text-center text-lg font-semibold border rounded-lg outline-none ${inputClasses.borderColor || "border-theme-border-strong"} ${getThemeClass(inputClasses.bgColor, "bg-theme-surface")} ${getThemeClass(inputClasses.textColor, "text-theme-text")} ${getThemeClass(inputClasses.focusBorderColor, "focus:border-theme-accent")} focus:ring-2 ${getThemeClass(inputClasses.focusRingColor, "focus:ring-theme-accent/40")} ${inputClasses.base}`}
        />
      ))}
    </div>
  );
}
